import React from "react";
import classNames from "classnames";
import { motion } from "framer-motion";
import { NAVBAR_THEMES, NavbarTheme } from "../../constants/themes";

type Props = {
  mode: NavbarTheme;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
};

const Pill = ({ mode, onClick, children, className }: Props) => {
  const theme = NAVBAR_THEMES[mode];
  return (
    <motion.button
      onClick={onClick}
      whileTap={{ scale: 0.96 }}
      transition={{ type: "spring", stiffness: 400, damping: 20 }}
      className={classNames(
        "h-10 border rounded-full px-3 flex items-center gap-2 text-sm font-medium focus:outline-none",
        "hover:border-primary hover:text-primary transition-colors",
        theme.pillBorder,
        theme.text,
        className,
      )}
    >
      {children}
    </motion.button>
  );
};

export default Pill;
